import { useKeybindingsStore } from '../store/keybindingsStore';
import { keyboardLayoutMap } from '../store/keyboardLayout';
import type { LayoutMapCache } from '../model/layoutMap';
import type { Keymap } from '../model/keybindingTypes';

// The keybindings store resolves scheme + overrides and validates them (D6);
// this module is the publication seam the dispatcher, useShortcutLabel and the
// app-menu config sync read. With no overrides the store's keymap is the Jam
// default keymap, so Slice 1 callers see what they saw before.
let effectiveKeymap: Keymap = useKeybindingsStore.getState().keymap;
const listeners = new Set<() => void>();

export function getEffectiveKeymap(): Keymap {
  return effectiveKeymap;
}

export function setEffectiveKeymap(nextKeymap: Keymap): void {
  effectiveKeymap = nextKeymap;
  listeners.forEach((listener) => listener());
}

export function subscribeEffectiveKeymap(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getKeybindingLayoutMap(): LayoutMapCache {
  return keyboardLayoutMap;
}

// The store keeps the previous keymap object when a change leaves it
// structurally equal, so identity is enough to skip no-op publications.
useKeybindingsStore.subscribe((state, previous) => {
  if (state.keymap !== previous.keymap) setEffectiveKeymap(state.keymap);
});
